import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { Crown } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FoundingWelcome = () => {
  const { user, setUser } = useAuth();
  const fired = useRef(false);

  useEffect(() => {
    if (!user?.founding_spot || user.founding_welcomed_at || fired.current) return;
    fired.current = true;
    const seat = user.founding_spot;
    toast.custom(
      () => (
        <div
          data-testid="founding-welcome-toast"
          className="flex items-start gap-3 w-[360px] border-2 border-[#B47A3C] bg-[#0D1B2A] text-[#FDFBF7] px-5 py-4 shadow-xl"
        >
          <Crown size={26} weight="fill" className="text-[#B47A3C] shrink-0 mt-0.5" />
          <div>
            <p className="font-serif-display text-lg font-bold leading-tight">
              Welcome, Seat #{seat} 👑
            </p>
            <p className="text-[13px] text-[#D8D3C8] mt-1 leading-relaxed">
              You're one of 20 founders steering this — your $29 rate is locked in for life.
              The roadmap is yours to shape.
            </p>
          </div>
        </div>
      ),
      { duration: 12000 }
    );
    api.post("/founding/welcome-ack").catch(() => {});
    setUser({ ...user, founding_welcomed_at: new Date().toISOString() });
  }, [user, setUser]);

  return null;
};

export default FoundingWelcome;
